import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { WebCustomerRoutePaths } from "../constants/Routes";
import CustomerLayout from "../Layouts/CustomerLayout";


const WebCustomerProtectedRoute = ({ component: Component, ...rest }) => {
    const { instance } = useMsal();
    const accounts = instance.getAllAccounts();
    const isAuthenticated = (accounts.length > 0) ? true : false;
    
    return (
        <Route {...rest} render={props => {
            if (!isAuthenticated) {
                return <Redirect to={{ pathname: WebCustomerRoutePaths.SELECT_PRINTER, state: { from: props.location } }} />
            }
            return(
                <CustomerLayout isSubscribed={rest.isSubscribed}>
                    <Component {...props} />
                </CustomerLayout>
            )
        }} />
    )
}

export default WebCustomerProtectedRoute;